import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { getSpecialityData } from '../reduxactions/adminactions/ASpecialityActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API } from '../ApiNames';
import { StepperPanel } from 'primereact/stepperpanel';
import { Stepper } from 'primereact/stepper';
import { getPaymentsData } from '../reduxactions/adminactions/AdminPaymentsActions';


export const AdminPayments = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');

    const data = useSelector((state: RootState) => state.payments.doctor);
  
    const dispatch = useDispatch();
    const stepperRef = useRef(null);

  
  const toast  = useRef(data);
  
    //To get data
    const fetchDataAsync = async () => {
      try {
        await dispatch(getPaymentsData() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    useEffectOnce(() => {
      fetchDataAsync();
    }, [dispatch]);

const navigate = useNavigate();
  const viewPage = (rowData: any) => {
    const url = `/viewprogramadmin/${rowData.CaseID}`;
    console.log('rowdata:', rowData.CaseID)
    navigate(url);
  }
    //for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/adminpayments.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };
  return (
    <div className="main-content">
    <div className="content-wrapper">
        <section className="content-header">
            <div className="container-fluid">
                <div className="grid mb-2">
                    <div className="col-9">
                        <h2> Payments</h2>
                    </div>
                     <div className="col-3">
                <a
                  title="help"
                 onClick={(e) => openWindow(e, IUrl)}
                  style={{
                   
                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                <i style={{marginTop: 40,backgroundColor: "orange",color:"white" }} className = "pi pi-question-circle"></i>
                 
                </a>
              </div>

                </div>
            </div>
        </section>
        <section className="content">
            <div className="row">
                <div className="col-md-12">
                    <div className="card-header p-2"></div>
                    <div className="box box-primary">
                        <div className="card"></div>
                        <div className="card flex flex-wrap justify-content">
                        </div>
                        <div className="card">
                            <Stepper ref={stepperRef}>
                                <StepperPanel header="Doctor Payments">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                </span>
                                            </div>
                                            <div className="card">
                                                <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['firstname','lastname','Amount','CreateDate']} >
                                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                    <Column header="Doctor Name" body={(rowData) =>  `${rowData.firstname.charAt(0).toUpperCase() + rowData.firstname.slice(1).toLowerCase()} ${rowData.lastname.charAt(0).toUpperCase() + rowData.lastname.slice(1).toLowerCase()}` } />
                                                    <Column field="Amount" sortable header="Amount"></Column>
                                                    <Column field="CreateDate" sortable header="Create Date"></Column>

                                                    <Column header="Operations" body={(rowData) => (
                                                        <div className="options-buttons">
                                                              <Button className='mr-1' tooltip="View" severity="info" icon="pi pi-eye" rounded outlined onClick={() => viewPage(rowData)} />
                                                        </div>
                                                    )}></Column>
                                                </DataTable>
                                            </div>
                                        </div>
                                    </p>
                                </StepperPanel>


                                <StepperPanel header="Hospital Payments">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                </span>
                                            </div>
                                            <div className="card">
                                                <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['firstname','lastname','Status','PaidDate']}>
                                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                    <Column header="Doctor Name" body={(rowData) =>  `${rowData.firstname.charAt(0).toUpperCase() + rowData.firstname.slice(1).toLowerCase()} ${rowData.lastname.charAt(0).toUpperCase() + rowData.lastname.slice(1).toLowerCase()}` } />
                                                    <Column field="PaidDate" sortable header="Paid Date"></Column>
                                                    <Column  sortable header="Status " body={(rowData) =>  `${rowData.Status.charAt(0).toUpperCase() + rowData.Status.slice(1).toLowerCase()} `}></Column>
                                                    {/* <Column field="status" sortable header="Open "></Column> */}
                                                    {/* <Column header="Option" body={(rowData) => (
                                                        <div className="options-buttons">
                                                            <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={()=>viewPage1(rowData)}/>
                                                        </div>
                                                    )}></Column> */}
                                                </DataTable>
                                            </div>
                                        </div>
                                    </p>
                                </StepperPanel>
                            </Stepper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div >
</div >
  )
}
